__turbopack_context__.v({
  "dropdown_list": "styles-module-scss-module__SOnYzW__dropdown_list",
  "error": "styles-module-scss-module__SOnYzW__error",
  "has_error": "styles-module-scss-module__SOnYzW__has_error",
  "info_icon": "styles-module-scss-module__SOnYzW__info_icon",
  "input_container": "styles-module-scss-module__SOnYzW__input_container",
  "input_field": "styles-module-scss-module__SOnYzW__input_field",
  "input_icon": "styles-module-scss-module__SOnYzW__input_icon",
  "input_label": "styles-module-scss-module__SOnYzW__input_label",
  "is_showing": "styles-module-scss-module__SOnYzW__is_showing",
  "label_with_tooltip": "styles-module-scss-module__SOnYzW__label_with_tooltip",
  "percent_symbol": "styles-module-scss-module__SOnYzW__percent_symbol",
  "tag": "styles-module-scss-module__SOnYzW__tag",
  "tag_container": "styles-module-scss-module__SOnYzW__tag_container",
  "with_percent": "styles-module-scss-module__SOnYzW__with_percent",
});
